import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultLayoutComponent } from './default-layout/default-layout.component';
import { ComponentsModule } from '../shared/components/components.module';
import { RouterModule } from '@angular/router';
import { ToastsContainer } from '../shared/components/toasts-container/toasts-container.component';

@NgModule({
  declarations: [DefaultLayoutComponent],
  imports: [RouterModule, ComponentsModule, CommonModule, ToastsContainer],
  exports: [DefaultLayoutComponent],
})
export class LayoutModule {}
